var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelatedEntityIndividual({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 123.5,
    r: 123.5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8C4.82875 8 3.0625 6.23375 3.0625 4.0625C3.0625 1.89125 4.82875 0.125 7 0.125C9.17125 0.125 10.9375 1.89125 10.9375 4.0625C10.9375 6.23375 9.17125 8 7 8ZM7 1.25C5.44915 1.25 4.1875 2.51169 4.1875 4.0625C4.1875 5.61331 5.44919 6.875 7 6.875C8.55081 6.875 9.8125 5.61331 9.8125 4.0625C9.8125 2.51169 8.55081 1.25 7 1.25ZM11.5 15.875H1.9375C1.00716 15.875 0.25 15.1178 0.25 14.1875C0.25 11.3965 2.52145 9.125 5.3125 9.125H8.125C10.916 9.125 13.1875 11.3965 13.1875 14.1875C13.1875 15.1178 12.4303 15.875 11.5 15.875ZM5.3125 10.25C3.14125 10.25 1.375 12.0162 1.375 14.1875C1.375 14.4975 1.62754 14.75 1.9375 14.75H11.5C11.81 14.75 12.0625 14.4975 12.0625 14.1875C12.0625 12.0162 10.2962 10.25 8.125 10.25H5.3125Z",
    fill: "#003D50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelatedEntityIndividual);
export default __webpack_public_path__ + "static/media/RelatedEntityIndividual.26940624d14012c53e7dc9e1e5aacb82.svg";
export { ForwardRef as ReactComponent };